import { render, staticRenderFns } from "./BoxIconField.vue?vue&type=template&id=58e88d61&scoped=true&"
import script from "./BoxIconField.vue?vue&type=script&lang=js&"
export * from "./BoxIconField.vue?vue&type=script&lang=js&"
import style0 from "./BoxIconField.vue?vue&type=style&index=0&id=58e88d61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e88d61",
  null
  
)

export default component.exports